module.exports = __webpack_public_path__ + "static/media/professor.f6e9e0b9.gif";